import axiosClient from '../../configs/axios';


class CylinderTagNoMasterService {

    async getCylinderTagMapList(params) {
        try {
            const response = await axiosClient.get(
                `/clytagmap/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    async addCylinderTagMap(data) {
        try {
            const response = await axiosClient.post('/clytagmap/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

  
    async editDeleteCylinderTagMap(data) {
        try {
            const response = await axiosClient.put(`/clytagmap/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new CylinderTagNoMasterService(); 